import _styled from "styled-components";
import React from "react";
import { AnimatePresence, m } from "framer-motion";
import { useMouseHovered } from "react-use";
type Props = {
  children: React.ReactNode;
  cursorPositionOffset?: number;
  isHidden?: boolean;
};
export function DeepDiveGalleryBound(props: Props) {
  const {
    children,
    cursorPositionOffset = 0,
    isHidden = true,
    ...rest
  } = props;
  const ref = React.useRef<HTMLDivElement>(null);
  const {
    elX,
    elY,
    elW,
    elH
  } = useMouseHovered(ref as React.RefObject<Element>, {
    bound: true
  });
  const [outOfBounds, setOutOfBounds] = React.useState(true);
  const cursorPos = `translate(calc(${elX}px - 50%), calc(${elY}px - (100% + ${cursorPositionOffset}px)))`;
  React.useEffect(() => {
    const isOutOfBoundsTop = elY <= 0;
    const isOutOfBoundsBottom = elY >= elH;
    const isOutOfBoundsRight = elX >= elW;
    const isOutOfBoundsLeft = elX <= 0;
    const isOutOfBounds = isOutOfBoundsTop || isOutOfBoundsRight || isOutOfBoundsBottom || isOutOfBoundsLeft;
    setOutOfBounds(isOutOfBounds);
  }, [elH, elW, elX, elY]);
  return <div ref={ref} {...rest}>
      {Boolean(children) && <_StyledDiv style={{
      transform: cursorPos
    }}>
          <AnimatePresence mode="wait">
            {!isHidden && !outOfBounds && <m.div initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} exit={{
          scale: 0
        }}>
                {children}
              </m.div>}
          </AnimatePresence>
        </_StyledDiv>}
    </div>;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "deep-dive-gallery-bound___StyledDiv",
  componentId: "sc-1w1o2on-0"
})({
  "position": "absolute",
  "zIndex": "10",
  "display": "none",
  "@media (min-width: 1024px)": {
    "display": "inline-block"
  }
});